// extracted by mini-css-extract-plugin
export default {"statusBadgeList":"statusBadgeList---IupyS"};